var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: "Personal Settings",
      staticClass: "container-fluid mb-5 px-md-5 form-page",
      attrs: { id: "settings-container" },
    },
    [
      _c("page-header", {
        attrs: {
          title: _vm.$t("settings.personalSettings"),
          size: "col-10 " + (_vm.isFullWidthTab ? "col-md-9" : "col-md-7"),
          "container-class": "justify-content-start",
        },
        scopedSlots: _vm._u([
          {
            key: "inlinebuttons",
            fn: function () {
              return [
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-lg-inline-flex flex-row d-none justify-content-end",
                    attrs: { cols: "3" },
                  },
                  [
                    _vm.currentTab === "theme"
                      ? _c(
                          "simple-button",
                          {
                            attrs: {
                              type: "white btn-sm",
                              "class-name": "mr-2",
                              disabled: !_vm.allowSave,
                            },
                            on: { click: _vm.handlePreviewTheme },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("global.actions.previewChanges")
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showSaveButton
                      ? _c(
                          "simple-button",
                          {
                            attrs: {
                              type: "primary btn-sm",
                              loading: _vm.saving,
                              "loading-status": _vm.savingStatus,
                              disabled: !_vm.allowSave,
                            },
                            on: { click: _vm.startSaving },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("global.actions.saveChanges")) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showResetVisibilitySettingsButton
                      ? _c(
                          "simple-button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip",
                                value: {
                                  title: _vm.$t(
                                    "settings.visibility.resetVisibilitySettingsTooltip"
                                  ),
                                },
                                expression:
                                  "{\n            title: $t('settings.visibility.resetVisibilitySettingsTooltip')\n          }",
                              },
                            ],
                            attrs: {
                              type: "primary btn-sm",
                              loading: _vm.resetting,
                              "loading-status": _vm.resettingStatus,
                              disabled: !_vm.allowReset,
                            },
                            on: { click: _vm.showResetVisibilitySettingsModal },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "settings.visibility.resetVisibilitySettings"
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showSaveButton
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "dropleft d-flex d-lg-none col-2 col-md-3 justify-content-end",
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "grey-text text-darken-4 clickable d-xl-none",
                            attrs: { "data-toggle": "dropdown" },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("more_vert"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown-menu" }, [
                          _vm.currentTab === "theme"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-item clickable wide px-4",
                                },
                                [
                                  _c(
                                    "simple-button",
                                    {
                                      attrs: {
                                        type: "white btn-sm",
                                        "class-name": "mr-2",
                                        disabled: !_vm.allowSave,
                                      },
                                      on: { click: _vm.handlePreviewTheme },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "global.actions.previewChanges"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-item clickable wide px-4",
                            },
                            [
                              _c(
                                "simple-button",
                                {
                                  attrs: {
                                    type: "primary btn-sm",
                                    loading: _vm.saving,
                                    "loading-status": _vm.savingStatus,
                                    disabled: !_vm.allowSave,
                                  },
                                  on: { click: _vm.startSaving },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("global.actions.saveChanges")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.loading
        ? _c("settings-loader")
        : _c(
            "div",
            [
              _c(
                "b-row",
                { staticClass: "pb-4" },
                [
                  _c("settings-navigation", {
                    attrs: {
                      tabs: _vm.tabs,
                      "current-tab": _vm.currentTab,
                      "settings-key": "personal-settings",
                    },
                    on: { "tab-change": _vm.handleTabChange },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      attrs: {
                        cols: "12",
                        md: _vm.isFullWidthTab ? "12" : "10",
                      },
                    },
                    [
                      _c(_vm.currentTabComponent, {
                        tag: "component",
                        attrs: {
                          saving: _vm.saving,
                          resetting: _vm.resetting,
                          "settings-type": _vm.settingsType,
                          "is-brokerage": false,
                          "allow-save": _vm.allowSave,
                          "nylas-account": _vm.nylasAccount,
                        },
                        on: {
                          "clear-nylas-account": function ($event) {
                            _vm.nylasAccount = {}
                          },
                          "finish-saving": _vm.finishSaving,
                          "finish-resetting": _vm.finishResetting,
                          "allow-save": _vm.handleAllowSave,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _vm._v(" "),
      _c("reset-visibility-settings-modal", {
        ref: "resetVisibilitySettingsModal",
        on: { "reset-visibility-settings": _vm.startResetting },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }